import { GEM_LACK_TRIGGER } from 'src/types/gemLack';

export const SHOP_ORIGIN = {
  ...GEM_LACK_TRIGGER,
  gemShop: 'GEM_SHOP',
  vipRating: 'VIP_RATING',
  starterPackageNudge: 'STARTER_PACKAGE_NUDGE',
} as const;

export type ShopOrigin = (typeof SHOP_ORIGIN)[keyof typeof SHOP_ORIGIN];

export enum ShopCategory {
  Normal = 'normal',
}
